import { axiosInstance } from './axiosInstance';

import { DownloadDocumentFactory } from '../../downloadDocument/DownloadDocument';

export const openWindowDownloadDocument: DownloadDocumentFactory = (submit) => {
  return ({ url, method, data, useNewWindow = true, fileName }) => {
    submit(() => {
      const newWindow = useNewWindow
        ? window.open(`${process.env.PUBLIC_URL}/download.html`)
        : null;

      return axiosInstance
        .request({
          method: method || 'GET',
          url,
          data,
          responseType: 'blob'
        })
        .then(
          ({ data }) => {
            const fileUrl = window.URL.createObjectURL(data);
            if (newWindow) {
              newWindow.location.href = fileUrl;
            } else if (fileName) {
              const link = document.createElement('a');
              link.href = fileUrl;
              link.download = fileName;
              link.style.display = 'none';
              document.body.append(link);
              link.click();
              window.URL.revokeObjectURL(fileUrl);
            }
          },
          (error) => {
            newWindow && newWindow.close();
            throw new Error(
              error && error.response && error.response.data
                ? error.response.data.userMessage
                : error
            );
          }
        );
    });
  };
};
